import { render } from "./SubmitReportSignUpOption.vue?vue&type=template&id=5c9da094&scoped=true&ts=true"
import script from "./SubmitReportSignUpOption.vue?vue&type=script&lang=ts"
export * from "./SubmitReportSignUpOption.vue?vue&type=script&lang=ts"

import "./SubmitReportSignUpOption.vue?vue&type=style&index=0&id=5c9da094&scoped=true&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9da094"]])

export default __exports__